import { createSlice } from '@reduxjs/toolkit';

export const cookies = createSlice({
  name: 'PUBLIC_KEYS',
  initialState: {}, // declare in store, not here as it will be over written by store

  reducers: {
    setEventPublicKeyString(state, action) {
      const { eventPublicKeyString } = action.payload;
      return {
        ...state,
        eventPublicKeyString,
      };
    },
  },
});

const { actions, reducer } = cookies;

export const { setEventPublicKeyString } = actions;

export default reducer;
